// index.ts
function add(data, field, value) {
  var _a;
  if (Array.isArray(value)) {
    (_a = data.fromMarkdownExtensions) != null ? _a : data.fromMarkdownExtensions = [];
    data.fromMarkdownExtensions.push(value);
    return;
  }
  if (data[field]) data[field].push(value);
  else data[field] = [value];
}
export {
  add
};
